import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const faqApi = createApi({
  reducerPath: "faqApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API+`statics/faq`,
  }),

  endpoints: (builder) => ({
    getFaqs: builder.query({
      query: () => "",
    }),
  }),
});

export const { useGetFaqsQuery } = faqApi;
